import { UserIcon } from '@/components/svg/user-icon/user-icon'
import cx from 'classnames'
import s from './capacity-info.module.scss'

type Props = {
  capacity: string | number
  className?: string
}

export const CapacityInfo = ({ capacity, className }: Props) => {
  return (
    <span
      role="img"
      className={cx(s.capacityInfo, className)}
      aria-label={`Capacity: ${capacity} guests`}
    >
      <UserIcon
        iconColor="currentColor"
        svgProps={{
          width: 14,
          height: 14,
          'aria-hidden': true,
          focusable: false,
        }}
      />
      <span aria-hidden>{capacity}</span>
    </span>
  )
}
